import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { AuthStatus } from '../interfaces'
import { useAuthStore } from '../stores/auth.store'

const isAuthenticatedGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const authStore = useAuthStore()

  if (authStore.authStatus == AuthStatus.Checking) await authStore.checkAuthStatus()

  if (authStore.authStatus !== AuthStatus.Authenticated) {
    next({ name: 'login' })
  } else {
    next()
  }
}

export default isAuthenticatedGuard
